"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _settings = require("@/model/settings");

var _index = require("@/i18n/index.js");

var _vuex = require("vuex");

//
//
//
//
//
var _default = {
  data: function data() {
    return {
      captchaObject: null,
      geeTestRegisterId: "",
      geeTestId: "",
      isOpen: true
    };
  },
  //   接受父组件传递的值，用来控制图形验证的加载
  props: ["isGeet", "isRegister"],
  methods: {
    GtCaptcha: function GtCaptcha() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var lang, _this, _yield$apiGetStaticTa, status, data, captchaId, handlerEmbed;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lang = (0, _index.getLanguage)() == "zh_CN" ? "zho" : (0, _index.getLanguage)() == "zh_HK" ? "zho-hk" : "eng";
                _this = _this2;
                _context.next = 4;
                return (0, _settings.apiGetStaticTableInfo)(75);

              case 4:
                _yield$apiGetStaticTa = _context.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (data) {
                  _context.next = 10;
                  break;
                }

                console.log("无所需数据");
                return _context.abrupt("return");

              case 10:
                data.forEach(function (element) {
                  if (element["type"] == "1" && element["platform"] == "3") {
                    _this2.geeTestRegisterId = element["captcha_id"];
                  }

                  if (element["type"] == "2" && element["platform"] == "3") {
                    _this2.geeTestId = element["captcha_id"];
                  }
                });
                captchaId = _this2.isRegister ? _this2.geeTestRegisterId : _this2.geeTestId;

                handlerEmbed = function handlerEmbed(captchaObj) {
                  captchaObj.onReady(function () {
                    _this.captchaObject = captchaObj;
                  }).onSuccess(function () {
                    var result = captchaObj.getValidate();
                    var param = {
                      captcha_output: result.captcha_output,
                      gen_time: result.gen_time,
                      lot_number: result.lot_number,
                      pass_token: result.pass_token
                    };

                    _this.$emit("geetParam", param);

                    captchaObj.reset();
                  }).onError(function () {//your code
                  });
                }; //   初始化极验


                _this.$initGeetest4({
                  language: lang,
                  captchaId: captchaId,
                  product: "bind"
                }, handlerEmbed);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    openGtCaptcha: function openGtCaptcha() {
      var captcha_conf = JSON.parse(sessionStorage.getItem("captcha_conf"));
      this.isOpen = captcha_conf.status; // 页面创建，调用函数

      if (this.isOpen == 1) {
        this.GtCaptcha();
      }
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    language: "user/language"
  })),
  created: function created() {
    this.openGtCaptcha();
  },
  mounted: function mounted() {},
  watch: {
    // 监听参数的变化，调用极验
    isGeet: function isGeet() {
      if (this.isOpen == 1) {
        var that = this; // this.captchaObject.showCaptcha(); //显示验证码

        var wait = setInterval(function () {
          if (that.captchaObject !== null) {
            clearInterval(wait);
            that.captchaObject.showCaptcha();
          }
        }, 100);
      } else {
        var param = {
          captcha_output: "",
          gen_time: "",
          lot_number: "",
          pass_token: ""
        };
        this.$emit("geetParam", param);
      }
    },
    language: function language(newValue, oldValue) {
      this.openGtCaptcha();
    }
  }
};
exports.default = _default;